import * as THREE from 'three';

/**
 * 将碰撞模型 group 的所有 mesh 替换为调试 wireframe 材质。
 * 仅在 debugCollision 模式下调用。
 */
export function applyCollisionDebugMaterial(group: THREE.Group): void {
  group.traverse((child) => {
    if ((child as THREE.Mesh).isMesh) {
      const mesh = child as THREE.Mesh;
      mesh.material = new THREE.MeshBasicMaterial({
        wireframe: true,
        color: 0x00ff88,
        transparent: true,
        opacity: 0.3,
        depthWrite: false,
      });
    }
  });
  group.visible = true;
}
